import { Button, useComputedColorScheme } from '@mantine/core';
import { useNotification } from '@refinedev/core';
import { IconFirstAidKit } from '@tabler/icons-react';
import { useGenerateBlueCrossPDF } from 'api/action/bluecross';
import { Claim } from 'interfaces';
import { Dispatch } from 'react';
import { buttonTextColor } from 'utils/buttonUtils';
import * as Sentry from '@sentry/react';

interface GenerateBlueCrossButtonProps {
  isLoading: boolean;
  setIsLoading: Dispatch<React.SetStateAction<boolean>>;
  disabled: boolean;
  selectedRow: Claim | null;
}

export const GenerateBlueCrossButton = ({
  isLoading,
  setIsLoading,
  disabled,
  selectedRow,
}: GenerateBlueCrossButtonProps) => {
  const { open } = useNotification();
  const computedColorScheme = useComputedColorScheme('dark');

  const textColor = buttonTextColor(computedColorScheme, disabled);

  const generateBlueCrossForm = useGenerateBlueCrossPDF();

  const handleOnClick = async () => {
    try {
      setIsLoading(true);
      const { url } = await generateBlueCrossForm.mutateAsync({
        claimID: selectedRow.id,
      });

      if (!url) {
        open({
          message: 'Failed to generate Blue Cross PDF',
          type: 'error',
        });
        return;
      }

      window.open(url, '_blank');
    } catch (error) {
      Sentry.captureException(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Button
      variant="outline"
      loading={isLoading}
      radius={'md'}
      c={textColor}
      leftSection={<IconFirstAidKit size={20} />}
      onClick={handleOnClick}
    >
      Generate Blue Cross PDF
    </Button>
  );
};
